
import { Options, Vue } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import { Dropdown } from "bootstrap";
import { DEFAULT_MEMBERS_SORT } from "@/services/repositories/orgMembersRepository";

@Options({})
export default class OrgMembersSort extends Vue {
  readonly defaultSort = DEFAULT_MEMBERS_SORT;

  @Ref() toggle!: HTMLElement;

  get currentSort(): string {
    return this.$store.state.organization?.membersSort || this.defaultSort;
  }

  get availableSorts(): { value: string; label: string }[] {
    return [
      {
        value: "name,asc",
        label: this.$t("organization.members.sorts.name"),
      },
      {
        value: "lastActivityDate,desc",
        label: this.$t("organization.members.sorts.lastActivityDesc"),
      },
      {
        value: "lastActivityDate,asc",
        label: this.$t("organization.members.sorts.lastActivityAsc"),
      },
      {
        value: "creationDate,desc",
        label: this.$t("organization.members.sorts.creationDate"),
      },
      {
        value: "registeringDate,desc",
        label: this.$t("organization.members.sorts.registeringDate"),
      },
    ];
  }

  changeSort(sort: string): void {
    // Close the menu before the sort changes: the toggle's class binding is re-rendered
    // and would otherwise wipe the "show" class Bootstrap relies on, leaving the menu open.
    if (this.toggle) {
      Dropdown.getOrCreateInstance(this.toggle).hide();
    }
    this.$store.dispatch(
      "organization/changeMembersSort",
      sort === this.defaultSort ? undefined : sort
    );
  }
}
